import { Box, Typography } from '@mui/material';
import styled from 'styled-components';
import LetterAvatar from '../LetterAvatar/LetterAvatar';
import { CoachBrandTagsTypes } from '../../types/coach';

interface INameCallProps {
  avatar: string;
  firstName: string;
  lastName: string | null;
  brandTag?: string | null;
}
interface IStyledTypographyProps {
  backgroundColor?: string;
  textColor?: string;
}

const StyledTypography = styled(Typography)<IStyledTypographyProps>(
  ({ backgroundColor, textColor }) => ({
    borderRadius: 10,
    background: backgroundColor,
    padding: '2px 6px',
    textAlign: 'center',
    '& span': {
      background: textColor,
      backgroundClip: 'text',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
    },
  })
);

function NameCell({ avatar, firstName, lastName, brandTag }: INameCallProps) {
  return (
    <Box>
      <Box display="flex" alignItems="center" gap="8px">
        {avatar ? (
          <img
            src={
              avatar.startsWith('https')
                ? avatar
                : `${process.env.REACT_APP_MEDIA_FILES_BASE_URL}${
                    avatar.startsWith('/') ? '' : '/'
                  }${avatar}`
            }
            alt="user-avatar"
            loading="lazy"
            style={{ width: '24px', height: '24px', borderRadius: '50%', objectFit: 'cover' }}
          />
        ) : (
          <LetterAvatar firstName={firstName} lastName={lastName} />
        )}
        <Typography variant="bodyRegular" color="primary">
          {firstName && lastName ? `${firstName} ${lastName}` : firstName || lastName || ''}
        </Typography>
        {brandTag === CoachBrandTagsTypes.IHTP && (
          <StyledTypography
            variant="tinyTexts"
            fontWeight={600}
            backgroundColor="#2A3C6726"
            textColor="#2A3C67"
          >
            <span>IHTP</span>
          </StyledTypography>
        )}
      </Box>
    </Box>
  );
}

export default NameCell;
